
  (() => {
    const uploadBlocks = document.querySelectorAll('[data-gfi-photo-upload]');
    if (!uploadBlocks.length) return;

    const formatBytes = (bytes) => {
      if (!bytes && bytes !== 0) return '';
      const mb = bytes / 1024 / 1024;
      return `${mb.toFixed(mb >= 10 ? 0 : 1)} MB`;
    };

    uploadBlocks.forEach((block) => {
      const input = block.querySelector('[data-gfi-upload-input]');
      const card = block.querySelector('[data-gfi-upload-card]');
      const preview = block.querySelector('[data-gfi-upload-preview]');
      const removeButton = block.querySelector('[data-gfi-upload-remove]');
      const filename = block.querySelector('[data-gfi-upload-filename]');
      const meta = block.querySelector('[data-gfi-upload-meta]');
      const error = block.querySelector('[data-gfi-upload-error]');
      const errorText = block.querySelector('[data-gfi-upload-error-text]');
      const errorClose = block.querySelector('[data-gfi-upload-error-close]');
      const buttonText = block.querySelector('[data-gfi-upload-button-text]');

      if (!input) return;

      const productForm = input.closest('form');

      const showError = (message = 'Please upload a photo to continue.') => {
        block.classList.add('has-error');

        if (errorText) {
          errorText.textContent = message;
        }

        if (error) {
          error.hidden = false;
        }
      };

      const hideError = () => {
        block.classList.remove('has-error');

        if (error) {
          error.hidden = true;
        }
      };

      const resetUpload = () => {
        input.value = '';
        block.classList.remove('has-file');
        hideError();

        if (card) card.hidden = true;
        if (preview) {
          preview.src = '';
          preview.hidden = true;
          preview.classList.remove('is-visible');
        }
        if (removeButton) removeButton.hidden = true;
        if (filename) filename.textContent = 'No file selected';
        if (meta) {
          meta.textContent = '';
          meta.hidden = true;
        }
        if (buttonText) buttonText.textContent = 'Choose photo';
      };

      const handleFile = () => {
        const file = input.files && input.files[0];

        if (!file) {
          resetUpload();
          return;
        }

        const allowedTypes = ['image/jpeg', 'image/png'];

        if (!allowedTypes.includes(file.type)) {
          resetUpload();
          showError('Please choose a JPG or PNG image.');
          return;
        }

        hideError();
        block.classList.add('has-file');

        if (filename) {
          filename.textContent = file.name;
        }

        if (meta) {
          meta.textContent = formatBytes(file.size);
          meta.hidden = false;
        }

        if (buttonText) {
          buttonText.textContent = 'Change photo';
        }

        if (card) {
          card.hidden = false;
        }

        if (removeButton) {
          removeButton.hidden = false;
        }

        if (preview) {
          const reader = new FileReader();

          reader.onload = (event) => {
            preview.src = event.target.result;
            preview.hidden = false;

            window.requestAnimationFrame(() => {
              preview.classList.add('is-visible');
            });
          };

          reader.readAsDataURL(file);
        }
      };

      input.addEventListener('change', handleFile);

      if (removeButton) {
        removeButton.addEventListener('click', resetUpload);
      }

      if (errorClose) {
        errorClose.addEventListener('click', hideError);
      }

    if (productForm) {
    const blockSubmission = (event) => {
        if (!input.files || !input.files.length) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        showError('Please upload a photo before adding this commission to your basket.');

        block.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });

        return false;
        }
    };

    productForm.addEventListener('submit', blockSubmission, true);

    const submitButtons = productForm.querySelectorAll(
        'button[type="submit"], input[type="submit"], .shopify-payment-button__button'
    );

    submitButtons.forEach((button) => {
        button.addEventListener(
        'click',
        (event) => {
            if (!input.files || !input.files.length) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            showError('Please upload a photo before adding this commission to your basket.');

            block.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });

            return false;
            }
        },
        true
        );
    });
    }
    });
  })();